import { ToggleGroup, ToggleGroupButton, WithTooltip } from '@compass/components'
import { formatNum } from 'helpers/format'

import { BOT_DETECTION_SOURCE_LABELS, BOT_DETECTION_SOURCE_TOOLTIPS } from '../consts'
import { BotDetectionSource } from '../models'

const SOURCE_TAB_IDS: BotDetectionSource[] = ['edge', 'identification']

const MAX_DISPLAYED_COUNT = 1000

function formatCount(count: number) {
  // totalHits is clamped at MAX_DISPLAYED_COUNT upstream, so hitting the cap means "this many or more".
  return count >= MAX_DISPLAYED_COUNT ? `${formatNum(MAX_DISPLAYED_COUNT)}+` : formatNum(count)
}

type BotDetectionSourceTabsProps = {
  value: BotDetectionSource
  counts: Record<BotDetectionSource, number | undefined>
  onChange: (source: BotDetectionSource) => void
}

/**
 * Segmented control that switches the overview and events listing between their two upstream data
 * sources. Rendered with ToggleGroup (Compass Tabs are underline-only) to get the segmented,
 * button-height look that sits inline with the filter/date controls.
 */
export function BotDetectionSourceTabs({ value, counts, onChange }: BotDetectionSourceTabsProps) {
  return (
    <ToggleGroup
      size='default'
      selectionMode='single'
      tone='background2'
      selectedKeys={new Set([value])}
      onSelectionChange={(keys) => {
        const nextSource = [...keys][0] as BotDetectionSource | undefined
        if (nextSource) {
          onChange(nextSource)
        }
      }}
    >
      {SOURCE_TAB_IDS.map((id) => {
        const count = counts[id]

        return (
          <WithTooltip key={id} content={BOT_DETECTION_SOURCE_TOOLTIPS[id]}>
            <ToggleGroupButton id={id}>
              {BOT_DETECTION_SOURCE_LABELS[id]}
              {count !== undefined && <span className='text-gray-800 font-normal'>{formatCount(count)}</span>}
            </ToggleGroupButton>
          </WithTooltip>
        )
      })}
    </ToggleGroup>
  )
}
